var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messages pa-4"},[_c('transition-group',{attrs:{"name":"messages","enter-active-class":"animated slideInRight","leave-active-class":"animated fadeOut"}},_vm._l((_vm.messages),function(ref){
var id = ref.id;
var type = ref.type;
var text = ref.text;
return _c('v-alert',{key:id,attrs:{"type":type,"min-width":"400","max-width":"400","dismissible":""}},[_vm._v(_vm._s(text))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }